<svelte:options
  customElement={{
    tag: "oc-sustainability-badge-v1",
    /*                                            */
    extend: window.__components.extend(),
    props: {
      asButton: { type: "Boolean", attribute: "as-button" }, /*    */
      variant: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { OcIconV1Props } from "src/components/icon/v1/IconV1.types.g";
  import type { Props } from "./SustainabilityBadgeV1.types";

  let { asButton = false, variant }: Props = $props();

  const ariaLabel: Record<Exclude<typeof variant, undefined>, string> = {
    "beruecksichtigt-tierwohl": "Berücksichtigt Tierwohl",
    "energieeffiziente-nutzung": "Energieeffiziente Nutzung",
    "foerderung-sozialer-initiativen": "Förderung Sozialer Initiativen",
    "kreislauffaehiges-design": "Kreislauffähiges Design",
    "materialien-aus-biologischem-anbau": "Materialien aus biologischem Anbau",
    naturkosmetik: "Naturkosmetik",
    "recycelte-materialien": "Recycelte Materialien",
    "verbesserte-herstellung": "Verbesserte Herstellung",
    "verbesserte-rohstoffbeschaffung": "Verbesserte Rohstoffbeschaffung",
  };

  const iconIdentifier: Record<Exclude<typeof variant, undefined>, OcIconV1Props["type"]> = {
    "beruecksichtigt-tierwohl": "sustainable-animal-welfare",
    "energieeffiziente-nutzung": "sustainable-energy-efficient",
    "foerderung-sozialer-initiativen": "sustainable-social-initiatives",
    "kreislauffaehiges-design": "sustainable-recyclable-design",
    "materialien-aus-biologischem-anbau": "sustainable-organic-materials",
    naturkosmetik: "sustainable-natural-cosmetics",
    "recycelte-materialien": "sustainable-recycling",
    "verbesserte-herstellung": "sustainable-production",
    "verbesserte-rohstoffbeschaffung": "sustainable-resource",
  };
</script>

{#snippet badgeIcon()}
  <oc-icon-v1
    oc-aria-label={ariaLabel[variant]}
    class="sustainability-badge__icon"
    size={"100"}
    type={iconIdentifier[variant]}
  ></oc-icon-v1>
{/snippet}

{#if asButton}
  <oc-interactive-overlay-v1
    class="sustainability-badge"
    class:sustainability-badge__interactive={asButton}
  >
    {@render badgeIcon()}
  </oc-interactive-overlay-v1>
{:else}
  <div class="sustainability-badge" class:sustainability-badge__interactive={asButton}>
    {@render badgeIcon()}
  </div>
{/if}

<style lang="scss" global>
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :host {
    @include mixins.no-tap-highlight();
    display: block;
    outline: none;
    border-radius: 50%;
  }

  .sustainability-badge {
    display: block;
    position: relative;
    background-color: tokens.$oc-component-sustainability-badge-background-color;
    border-radius: 50%;
    border: none;
    height: tokens.$oc-component-sustainability-badge-background-size;
    width: tokens.$oc-component-sustainability-badge-background-size;
    outline: none;
    outline-offset: 0;

    &__icon {
      --color: #{tokens.$oc-component-sustainability-badge-icon-color};

      left: 50%;
      top: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
    }

    &__interactive {
      --border-radius: 50%;
      --border-offset: 0px; /*                                                    */
    }
  }
</style>
